module.exports = __webpack_public_path__ + "img/4door_driving.018987b4.svg";